import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 16v-8l4 8v-8","key":"svg-0"}]]

const IconLetterNSmall = createReactComponent('outline', 'letter-n-small', 'LetterNSmall', __iconNode);

export default IconLetterNSmall;